import request from '@/utils/request'



//查询
export function queryPage(params) {
  return request({
    url: '/admin/worker/task/queryPage',
    method: 'get',
    params: params
  })
}

//添加
export function add(data) {
  return request({
    url: '/admin/worker/task/add',
    method: 'post',
    data: data
  })
}

//删除
export function del(params) {
  return request({
    url: '/admin/worker/task/delete',
    method: 'get',
    params: params
  })
}


//备注
export function confirmNode(params) {
  return request({
    url: '/admin/worker/task/confirmNode',
    method: 'post',
    data: params
  })
}

//获取任务详情
export function getItem(params) {
  return request({
    url: '/admin/worker/task/getItem',
    method: 'get',
    params: params
  })
}





// WEBPACK FOOTER //
// ./src/api/WorkerTask.js